import React, { useEffect } from "react";
import { Button, Badge } from "reactstrap";
import { toast } from "react-toastify";

const AddonSelector = ({
  addon,
  onSelect,
  onNext,
  onBack,
  showBack,
  selectedOptions,
}) => {

  const handleSelectOption = (option) => {
    onSelect(addon, option);
    if (!addon.is_multiple) {
      setTimeout(() => onNext(), 100);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key >= "1" && e.key <= "9") {
        const idx = parseInt(e.key) - 1;
        if (idx < addon.options.length) {
          e.preventDefault();
          handleSelectOption(addon.options[idx]);
        }
      } else if (e.ctrlKey && e.key === " " && addon.is_multiple) {
        e.preventDefault();
        onNext();
      } else if (e.key === "ArrowRight" && addon.is_multiple) {
        e.preventDefault();
        onNext();
      } else if (e.key === "ArrowLeft" && showBack) {
        e.preventDefault();
        onBack();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [addon, onNext, onBack, showBack]);

  const currentSelections = selectedOptions[addon.id] || {};
  const selectedOptionsList = Object.keys(currentSelections)
    .filter((optId) => currentSelections[optId])
    .map((optId) => addon.options.find((o) => o.id === optId))
    .filter(Boolean);

  return (
    <div className="conversational-addon-container">
      <div className="mb-4">
        <h4 style={{ color: "#fff", fontWeight: "600", marginBottom: "8px" }}>
          {addon.title}
          {addon.is_required && (
            <span style={{ color: "red", marginLeft: "4px" }}>*</span>
          )}
        </h4>
        <p className="text-muted" style={{ fontSize: "14px", marginBottom: "0", color: "#ddd" }}>
          Press 1-9 for quick select
          {addon.is_multiple && <span> • Ctrl+Space to continue</span>}
        </p>
      </div>

      {selectedOptionsList.length > 0 && (
        <div className="mb-3">
          <p className="text-muted mb-2" style={{ color: "#aaa" }}>Selected:</p>
          <div className="d-flex flex-wrap gap-2">
            {selectedOptionsList.map((option) => (
              <Badge key={option.id} color="success" pill>
                {option.option}
                {option.price && ` (+$${parseFloat(option.price).toFixed(2)})`}
              </Badge>
            ))}
          </div>
        </div>
      )}



      <div className="available-options">
        <div className="d-flex flex-wrap gap-3">
          {addon.options.map((option, index) => (
            <div
              key={option.id}
              onClick={() => handleSelectOption(option)}
              style={{
                position: "relative",
                width: "120px",
                cursor: "pointer",
                transition: "transform 0.2s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              {option.imageUrl ? (
                <div
                  style={{
                    width: "120px",
                    height: "120px",
                    border: currentSelections[option.id]
                      ? "4px solid #28a745"
                      : "2px solid #e0e0e0",
                    borderRadius: "12px",
                    overflow: "hidden",
                    position: "relative",
                    boxShadow: currentSelections[option.id]
                      ? "0 4px 12px rgba(40, 167, 69, 0.3)"
                      : "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <img
                    src={option.imageUrl}
                    alt={option.option}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      left: "6px",
                      background: "rgba(0,0,0,0.8)",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    {index + 1}
                  </div>
                  {currentSelections[option.id] && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        background: "rgba(40, 167, 69, 0.9)",
                        color: "white",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "24px",
                      }}
                    >
                      ✓
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    width: "120px",
                    height: "120px",
                    border: currentSelections[option.id]
                      ? "4px solid #28a745"
                      : "2px solid #e0e0e0",
                    borderRadius: "12px",
                    position: "relative",
                    background: option.color || "#f8f9fa",
                    boxShadow: currentSelections[option.id]
                      ? "0 4px 12px rgba(40, 167, 69, 0.3)"
                      : "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      left: "6px",
                      background: "rgba(0,0,0,0.8)",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    {index + 1}
                  </div>
                  {currentSelections[option.id] && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        background: "rgba(40, 167, 69, 0.9)",
                        color: "white",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "24px",
                      }}
                    >
                      ✓
                    </div>
                  )}
                </div>
              )}
              <div
                style={{
                  marginTop: "8px",
                  textAlign: "center",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#fff",
                }}
              >
                {option.option}
                {option.price && (
                  <div style={{ color: "#28a745", fontSize: "12px" }}>
                    +${parseFloat(option.price).toFixed(2)}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {showBack && (
        <div className="mt-3">
          <Button size="sm" color="secondary" outline onClick={onBack}>
            ← Back
          </Button>
        </div>
      )}
    </div>
  );
};

export default AddonSelector;
